import * as actionType from "../actions/actionType";

const initialState = {
  goodsName: "",
  showStatus: "",
  openStatus: "",
  startTime: "",
  endTime: "",
  page: 1,
  size: 20,
  tableList: [],
  loading: false,
  editLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.PACKAGELIST_UPDATE_STATE:
      return {
        ...state,
        ...action.payload.obj,
      };
    default:
      return state;
  }
};
